import { configureStore } from '@reduxjs/toolkit';

import { loyaltyReducer } from './models/loyalty';

export const store = configureStore({
  reducer: {
    loyalty: loyaltyReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
